import React, {ReactNode} from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
import { DS } from '@/design-system'

function Card ({ children, style }: { children: ReactNode, style?: ViewStyle }){
  return (
    <View style={[styles.card, style]}>
      {children}
    </View>
  )
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 16,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    padding: 20,
    gap: 16
  }
})

export default Card
